import { PresetPicker } from "./preset-picker.tsx";

interface ContextInputProps {
  triggerWord: string;
  suggestions: string[];
  onSubmit: (context: string) => void;
  defaultValue?: string | null;
}

/**
 * Context step input with quick-pick suggestion pills and a free-text fallback.
 *
 * Type-to-filter: when the pills container has focus, printable characters
 * redirect to the text input and filter the visible suggestions.
 */
export function ContextInput({
  triggerWord,
  suggestions,
  onSubmit,
  defaultValue,
}: ContextInputProps) {
  return (
    <PresetPicker
      options={suggestions}
      onSelect={onSubmit}
      defaultValue={defaultValue}
      placeholder="Type to filter or enter custom..."
      ariaLabel="Suggestions"
      layout="pills"
      pillPrefix={triggerWord}
    />
  );
}
